import React from 'react';
import * as d3 from 'd3';
import { clientPoint } from 'd3-selection';
import { formatTextFloat, formatPercent } from './../../helpers/Text';

class Arc extends React.Component {
  constructor(props) {
    super(props);
    this.arc = props.createArc;
  }

  componentDidMount() {
    this.draw();
  }

  draw() {
    const { data, index } = this.props;

    d3.select(this.refs.arc)
      .datum(data)
      .attr('d', null)
      .transition()
      .delay(() => {
        return index * 20;
      })
      .duration(500)
      .attrTween('d', d => {
        const i = d3.interpolate(d.startAngle + 0.1, d.endAngle);
        return t => {
          d.endAngle = i(t);
          return this.arc(d);
        };
      });
  }

  componentDidUpdate(prevProps) {
    const { createArc, data } = this.props;

    if (data !== prevProps.data) {
      this.arc(createArc);
      this.draw();
    }
  }

  getTooltip = data => {
    const { renderTooltip } = this.props;
    if (renderTooltip && typeof renderTooltip === 'function') {
      return renderTooltip(data.data.item2);
    }

    return `${formatTextFloat(formatPercent(data.data.item2))} %`;
  };

  render() {
    const {
      data,
      index,
      colors,
      idTooltip,
      tooltipPaddingX,
      tooltipPaddingY,
    } = this.props;
    const arc = this.arc(data);

    return (
      <g key={index} className="arc" id="donut">
        <path
          ref="arc"
          d={arc}
          fill={colors[index]}
          onMouseMove={e => {
            d3
              .select(`#${idTooltip}`)
              .style(
                'left',
                clientPoint(e.target, e)[0] + tooltipPaddingX + 'px',
              )
              .style(
                'bottom',
                -clientPoint(e.target, e)[1] + tooltipPaddingY + 'px',
              )
              .style('display', 'inline-table')
              .select('#value').html(`<div class="tooltip-custom">
                <span class="color-wrapper" style="background-color : ${
                  colors[index]
                }">
                </span>
                <div class="text-nowrap">
                  ${data.data.item1}
                  <a style="font-weight: bold">
                    ${this.getTooltip(data)}
                  </a>
                </div>
               </div>`);
          }}
          onMouseOut={() => {
            d3.select(`#${idTooltip}`).style('display', 'none');
          }}
        />
      </g>
    );
  }
}

export default Arc;
